import React from 'react';

export function IconBox({children,classExtra}) {
  return (
    <div className="rounded-lg text-gray-400 hover:text-gray-500">
      <span className="sr-only">View grid</span>
      <div aria-labelledby="grid switch buttons" className="flex space-x-1">
        <div
          className={`border-[1px] border-gray-300 rounded-md w-[2.2rem] h-[2.2rem] group flex justify-center items-center border-1 ${classExtra}`}
          aria-hidden="true"
        >
          {children}
        </div>{' '}
      </div>
    </div>
  );
}
